import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { FabricCategoryDto } from '../../models/fabric-categories/fabric-category-dto.interface';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class FabricCategoryProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/fabric-categories';

  getAllFabricCategories(): Observable<ApiResponse<FabricCategoryDto[]>> {
    return this.httpClient.get<ApiResponse<FabricCategoryDto[]>>(`${this.baseUrl}/all`);
  }
}
